import { ExternalLink } from "../core/views/ExternalLink";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { DocumentationIcon } from "./DocumentationIcon";

/**
 * Button for the sidebar to open the docs page
 */
function DocsLink() {
  return (
    <ExternalLink to="https://docs.upsolver.com/upsolver-1/">
      <IconButton title="Read our documentation" size="large">{DocumentationIcon}</IconButton>
    </ExternalLink>
  );
}

export default DocsLink;
